import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CfButtonComponent } from '@ui/cf-button/cf-button.component';
import { CfProfileComponent } from '@ui/cf-profile/cf-profile.component';
import { CfStatusDisplayComponent } from '@ui/cf-status-display/cf-status-display.component';
import { CfUserProfileStackComponent } from '@ui/cf-user-profile-stack/cf-user-profile-stack.component';
import { CfTableColumnType, ICFTableColumnButtonOptions, ICFTableColumnTypeOptions } from './cf-table.component';

@Component({
    selector: 'app-cf-table-cell',
    template: `
@switch(columnType) {
    @case('status') { <app-cf-status-display [status]="column"></app-cf-status-display> }
    @case('profile') { @if(column) { <app-cf-profile [urlOrInitials]="column" [width]="profileSizePx" [height]="profileSizePx" [bgColor]="profileBgColor" [textColor]="profileTextColor"></app-cf-profile> } }
    @case('profiles') { @if(column) { <app-cf-user-profile-stack [users]="column" [width]="profileSizePx" [height]="profileSizePx" [bgColor]="profileBgColor" [textColor]="profileTextColor"></app-cf-user-profile-stack> } }
    @case('button') { @if(options?.button && column) { <app-cf-button [type]="options?.button?.type!" (click)="buttonClicked()">{{column}}</app-cf-button> } }
    @case('icon') { @if(column) { <i [class]="column" (click)="iconClicked($event)"></i> } }
    @default { {{column}} }
}`,
    styles: [``],
    imports: [CfStatusDisplayComponent, CfProfileComponent, CfUserProfileStackComponent, CfButtonComponent]
})
export class CfTableCellComponent {
    @Input() columnType!: CfTableColumnType;
    @Input() column: any;
    @Input() options?: undefined | ICFTableColumnTypeOptions;
    @Input() profileSizePx = 50;
    @Input() profileBgColor?: string;
    @Input() profileTextColor?: string;

    @Output() click = new EventEmitter<string>();

    buttonClicked(): void {
        this.click.emit(this.column);
    }

    iconClicked(event: MouseEvent): void {
        event.stopPropagation();
        this.click.emit(this.column);
    }
}
